<div class="container text-center">

  <img src="../../../../assets/images/logo-1.png" alt="logo" >

  <div class="display3 fg-orange mt-0">404</div>
  <div class="h3 text-center m-8">Oops!<br>Page not found.</div>

  <div class="text-leader2 text-center page-error-box mx-auto">
    We could not find the page you were looking for.
    <br>Meanwhile, you may <a (click)="goToUrl()" style="color: blue; cursor: pointer;">return to dashboard</a> or try using the search form.
  </div>

  <form class="p-4 mx-auto page-error-box" action="javascript:">
    <input type="text" data-role="input" data-custom-buttons="customButtons" placeholder="Search..." class="input-large">
  </form>
</div>
